import { Card } from "antd";
import React from "react";
import { Container } from "../Container";
import "./index.scss";
export var NftsOverview = function NftsOverview(_ref) {
  var nfts = _ref.nfts,
      lazy = _ref.lazy,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(Container, {
    isGridCard: true
  }, /*#__PURE__*/React.createElement(Card, {
    title: title
  }, nfts.length === 0 ? /*#__PURE__*/React.createElement(NoNFTs, null) : /*#__PURE__*/React.createElement(Nfts, {
    nfts: nfts,
    lazy: lazy
  })));
};

var Nfts = function Nfts(_ref2) {
  var nfts = _ref2.nfts,
      lazy = _ref2.lazy;
  return /*#__PURE__*/React.createElement(React.Fragment, null, nfts && nfts.map(function (nft, index) {
    return /*#__PURE__*/React.createElement(NftItem, {
      nft: nft,
      key: index,
      lazy: lazy
    });
  }));
};

var NoNFTs = function NoNFTs() {
  return /*#__PURE__*/React.createElement("div", {
    className: "no-nfts"
  }, "No NFTs yet.");
};

var NftItem = function NftItem(_ref3) {
  var _nft$sold, _nft$created;

  var nft = _ref3.nft,
      lazy = _ref3.lazy;
  var gridStyle = {
    width: "100%",
    align: "center"
  };
  return /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: false,
    style: gridStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "nftItem"
  }, /*#__PURE__*/React.createElement("img", {
    className: "nftImage",
    src: nft.imageUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "nftInfo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nftName"
  }, nft.name), /*#__PURE__*/React.createElement("div", null, "Product ID: ", nft.productId), /*#__PURE__*/React.createElement("div", null, "Chain: ", nft.chain), nft.transactionId && /*#__PURE__*/React.createElement("div", null, "Tx ID:", " ", /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    href: nft.transactionLink
  }, nft.transactionId)), nft.tokenId && /*#__PURE__*/React.createElement("div", null, "Token ID:", nft.tokenId), nft.transactionId || nft.errorCause ? /*#__PURE__*/React.createElement(DateFormatted, {
    label: "Sold",
    date: nft === null || nft === void 0 ? void 0 : (_nft$sold = nft.sold) === null || _nft$sold === void 0 ? void 0 : _nft$sold.date
  }) : /*#__PURE__*/React.createElement(DateFormatted, {
    label: "Created",
    date: nft === null || nft === void 0 ? void 0 : (_nft$created = nft.created) === null || _nft$created === void 0 ? void 0 : _nft$created.date
  }), nft.errorCause && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "Error cause: ".concat(nft.errorCause)
    }
  }))));
};

var DateFormatted = function DateFormatted(_ref4) {
  var date = _ref4.date,
      label = _ref4.label;

  if (!date) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  var localizedDate = new Date(date.replace(/ /g, "T"));
  return /*#__PURE__*/React.createElement("div", null, label, " ", localizedDate.toLocaleString());
};